module.exports = __webpack_public_path__ + "img/ico2.86bb746f.png";